import React, { useEffect, useState } from 'react';
import { Text, DropdownList } from '@cyberpion/cyberpion-ui';
import { RestApi } from 'common/services/rest-api.service';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, IReduxState } from 'app/store';
import { showSuccess } from 'features/AlertSlice';
import { setSummaryMarkdown, setSummaryAiRoleOptions, setSummaryAiSelectedRole } from 'features/popSideSlice';
import Lottie from 'lottie-react-web';
import animation from './summaryProgressBar_lottie.json';
import { useFlags } from 'launchdarkly-react-client-sdk';
import classNames from 'classnames';
import { Amplitude } from 'common/services/amplitude.service';

import './PopSideIonixAiSummaryTab.scss';

const iconProgress = (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path
      d="M6.62095 15.3791L1.5668 13.5167C1.42743 13.4652 1.30719 13.3723 1.22226 13.2504C1.13733 13.1286 1.0918 12.9836 1.0918 12.835C1.0918 12.6865 1.13733 12.5415 1.22226 12.4196C1.30719 12.2977 1.42743 12.2048 1.5668 12.1534L6.62095 10.291L8.48335 5.23682C8.53479 5.09746 8.62771 4.97721 8.74959 4.89228C8.87147 4.80735 9.01645 4.76182 9.165 4.76182C9.31356 4.76182 9.45854 4.80735 9.58042 4.89228C9.7023 4.97721 9.79522 5.09746 9.84666 5.23682L11.7091 10.291L16.7632 12.1534C16.9026 12.2048 17.0228 12.2977 17.1077 12.4196C17.1927 12.5415 17.2382 12.6865 17.2382 12.835C17.2382 12.9836 17.1927 13.1286 17.1077 13.2504C17.0228 13.3723 16.9026 13.4652 16.7632 13.5167L11.7091 15.3791L9.84666 20.4332C9.79522 20.5726 9.7023 20.6928 9.58042 20.7778C9.45854 20.8627 9.31356 20.9082 9.165 20.9082C9.01645 20.9082 8.87147 20.8627 8.74959 20.7778C8.62771 20.6928 8.53479 20.5726 8.48335 20.4332L6.62095 15.3791Z"
      fill="url(#paint0_linear_11_2178)"
    />
    <path
      d="M15.0366 1.09185V5.49554M19.4403 6.22949V9.16529M12.8347 3.2937H17.2384M17.9724 7.69739H20.9082M6.62095 15.3791L1.5668 13.5167C1.42743 13.4652 1.30719 13.3723 1.22226 13.2504C1.13733 13.1286 1.0918 12.9836 1.0918 12.835C1.0918 12.6865 1.13733 12.5415 1.22226 12.4196C1.30719 12.2977 1.42743 12.2048 1.5668 12.1534L6.62095 10.291L8.48335 5.23682C8.53479 5.09746 8.62771 4.97721 8.74959 4.89228C8.87147 4.80735 9.01645 4.76182 9.165 4.76182C9.31356 4.76182 9.45854 4.80735 9.58042 4.89228C9.7023 4.97721 9.79522 5.09746 9.84666 5.23682L11.7091 10.291L16.7632 12.1534C16.9026 12.2048 17.0228 12.2977 17.1077 12.4196C17.1927 12.5415 17.2382 12.6865 17.2382 12.835C17.2382 12.9836 17.1927 13.1286 17.1077 13.2504C17.0228 13.3723 16.9026 13.4652 16.7632 13.5167L11.7091 15.3791L9.84666 20.4332C9.79522 20.5726 9.7023 20.6928 9.58042 20.7778C9.45854 20.8627 9.31356 20.9082 9.165 20.9082C9.01645 20.9082 8.87147 20.8627 8.74959 20.7778C8.62771 20.6928 8.53479 20.5726 8.48335 20.4332L6.62095 15.3791Z"
      stroke="white"
      stroke-width="1.4679"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.0366 1.09185V5.49554M19.4403 6.22949V9.16529M12.8347 3.2937H17.2384M17.9724 7.69739H20.9082M6.62095 15.3791L1.5668 13.5167C1.42743 13.4652 1.30719 13.3723 1.22226 13.2504C1.13733 13.1286 1.0918 12.9836 1.0918 12.835C1.0918 12.6865 1.13733 12.5415 1.22226 12.4196C1.30719 12.2977 1.42743 12.2048 1.5668 12.1534L6.62095 10.291L8.48335 5.23682C8.53479 5.09746 8.62771 4.97721 8.74959 4.89228C8.87147 4.80735 9.01645 4.76182 9.165 4.76182C9.31356 4.76182 9.45854 4.80735 9.58042 4.89228C9.7023 4.97721 9.79522 5.09746 9.84666 5.23682L11.7091 10.291L16.7632 12.1534C16.9026 12.2048 17.0228 12.2977 17.1077 12.4196C17.1927 12.5415 17.2382 12.6865 17.2382 12.835C17.2382 12.9836 17.1927 13.1286 17.1077 13.2504C17.0228 13.3723 16.9026 13.4652 16.7632 13.5167L11.7091 15.3791L9.84666 20.4332C9.79522 20.5726 9.7023 20.6928 9.58042 20.7778C9.45854 20.8627 9.31356 20.9082 9.165 20.9082C9.01645 20.9082 8.87147 20.8627 8.74959 20.7778C8.62771 20.6928 8.53479 20.5726 8.48335 20.4332L6.62095 15.3791Z"
      stroke="url(#paint1_linear_11_2178)"
      stroke-width="1.4679"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11_2178"
        x1="11"
        y1="1.09185"
        x2="11"
        y2="20.9082"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AEB8F5" />
        <stop offset="1" stop-color="#3455DD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_11_2178"
        x1="11"
        y1="1.09185"
        x2="11"
        y2="20.9082"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AEB8F5" />
        <stop offset="1" stop-color="#3455DD" />
      </linearGradient>
    </defs>
  </svg>
);

const iconClipboard = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <rect
      x="1.125"
      y="3.375"
      width="7.5"
      height="7.5"
      rx="0.75"
      stroke="#5D6576"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.375 3.375V1.875C3.375 1.46079 3.71079 1.125 4.125 1.125H10.125C10.5392 1.125 10.875 1.46079 10.875 1.875V7.875C10.875 8.28921 10.5392 8.625 10.125 8.625H8.625"
      stroke="#5D6576"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const iconThumbsUp = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path
      d="M4.99512 6.79681H1.99512C1.86251 6.79681 1.73533 6.84949 1.64156 6.94326C1.5478 7.03703 1.49512 7.16421 1.49512 7.29681V12.7968C1.49512 12.9294 1.5478 13.0566 1.64156 13.1504C1.73533 13.2441 1.86251 13.2968 1.99512 13.2968H4.99512M4.99512 6.79681V13.2968M4.99512 6.79681L7.49512 1.79681C8.02555 1.79681 8.53426 2.00753 8.90933 2.3826C9.2844 2.75767 9.49512 3.26638 9.49512 3.79681V5.29681H13.4951C13.637 5.29685 13.7772 5.32707 13.9065 5.38546C14.0357 5.44385 14.1511 5.52908 14.2449 5.63548C14.3387 5.74188 14.4088 5.86703 14.4506 6.0026C14.4923 6.13817 14.5047 6.28107 14.487 6.42181L13.737 12.4218C13.7066 12.6634 13.589 12.8856 13.4064 13.0467C13.2238 13.2078 12.9886 13.2967 12.7451 13.2968H4.99512"
      stroke="#5D6576"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const iconThumbsDown = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path
      d="M4.99512 3.29681H1.99512C1.86251 3.29681 1.73533 3.34949 1.64156 3.44326C1.5478 3.53703 1.49512 3.66421 1.49512 3.79681V9.29681C1.49512 9.42942 1.5478 9.5566 1.64156 9.65037C1.73533 9.74414 1.86251 9.79681 1.99512 9.79681H4.99512M4.99512 3.29681V9.79681M4.99512 3.29681H12.7451C12.9886 3.29688 13.2238 3.38581 13.4064 3.54691C13.589 3.70801 13.7066 3.9302 13.737 4.17181L14.487 10.1718C14.5047 10.3126 14.4923 10.4555 14.4506 10.591C14.4088 10.7266 14.3387 10.8517 14.2449 10.9581C14.1511 11.0645 14.0357 11.1498 13.9065 11.2082C13.7772 11.2666 13.637 11.2968 13.4951 11.2968H9.49512V12.7968C9.49512 13.3272 9.2844 13.836 8.90933 14.211C8.53426 14.5861 8.02555 14.7968 7.49512 14.7968L4.99512 9.79681"
      stroke="#5D6576"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const ProgressSummary = () => {
  const defaultOptions = {
    animationData: animation,
    loop: true
  };
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1
      }}
    >
      <div style={{ marginBottom: 20 }}>{iconProgress}</div>
      <Text textColor="#3455DD" textSize={13} style={{ marginBottom: 16 }}>
        Generating Summary...
      </Text>
      <div className="summary-lottie">
        <Lottie options={defaultOptions} height={'20px'} />
      </div>
    </div>
  );
};

function escapeHtml(str: string) {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/!/g, '&#33;');
}

const markdownToHtml = (markdown: any) => {
  let html = markdown;

  // Code blocks (```code```)
  html = html.replace(
    /```html([\s\S]*?)```/gim,
    (_: any, code: any) =>
      `<pre style="background-color: #F9FAFF; border: 1px solid #ECECEC; border-radius: 4px"><code style="white-space: break-spaces; font-family: Courier, monospace">${escapeHtml(
        code
      )}</code></pre>`
  );
  html = html.replace(
    /```javascript([\s\S]*?)```/gim,
    (_: any, code: any) =>
      `<pre style="background-color: #F9FAFF; border: 1px solid #ECECEC; border-radius: 4px"><code style="white-space: break-spaces; font-family: Courier, monospace">${escapeHtml(
        code
      )}</code></pre>`
  );
  html = html.replace(
    /```([\s\S]*?)```/gim,
    (_: any, code: any) =>
      `<pre style="background-color: #F9FAFF; border: 1px solid #ECECEC; border-radius: 4px"><code style="white-space: break-spaces; font-family: Courier, monospace">${escapeHtml(
        code
      )}</code></pre>`
  );

  // Inline code (`code`)
  html = html.replace(
    /`([^`]+)`/gim,
    '<code style="color: #D7BA7D; background-color: #F0F2F6; padding: 1px 4px; border-radius: 4px; font-family: Courier, monospace">$1</code>'
  );

  html = html.replace(/^###### (.*$)/gim, '<h6 style="margin: 0">$1</h6>');
  html = html.replace(/^##### (.*$)/gim, '<h5 style="margin: 0">$1</h5>');
  html = html.replace(/^#### (.*$)/gim, '<h4 style="margin: 0">$1</h4>');
  html = html.replace(/^### (.*$)/gim, '<h3 style="margin: 0">$1</h3>');
  html = html.replace(/^## (.*$)/gim, '<h2 style="margin: 0">$1</h2>');
  html = html.replace(/^# (.*$)/gim, '<h1 style="margin: 0">$1</h1>');

  // Blockquotes
  html = html.replace(/^> (.*$)/gim, '<blockquote>$1</blockquote>');

  // Images
  html = html.replace(/!\[(.*?)\]\((.*?)\)/gim, "<img alt='$1' src='$2' />");

  // Links
  html = html.replace(/\[(.*?)\]\((.*?)\)/gim, "<a href='$2' target='_blank'>$1</a>");

  // Bold
  html = html.replace(/\*\*(.*?)\*\*/gim, '<b>$1</b>');

  // Italic
  html = html.replace(/\*(.*?)\*/gim, '<i>$1</i>');

  // Unordered Lists
  html = html.replace(/^- (.*$)/gim, '<li>$1</li>');
  if (html.includes('<li>')) {
    html = html.replace(/(<li>.*<\/li>)/gim, '<ul style="margin: 0; padding-left: 24px">$1</ul>');
  }

  // Line breaks
  html = html.replace(/\n/gim, '<br />');

  return html.trim();
};

// Typing animation component
const TypingAnimation = ({
  text,
  refScrollText,
  isAnimation,
  setShowDisclaimer
}: {
  text: string;
  refScrollText: any;
  isAnimation: boolean;
  setShowDisclaimer: (show: boolean) => void;
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const processedText = markdownToHtml(text);

  useEffect(() => {
    if (isAnimation) {
      if (currentIndex < processedText.length) {
        const timeout = setTimeout(() => {
          setDisplayedText(
            `${processedText.substring(0, currentIndex + 4)}${
              currentIndex + 10 < processedText.length ? '<span style="padding: 0px 6px">|</span>' : ''
            }`
          );
          setCurrentIndex(currentIndex + 4);
        }, 10);
        return () => clearTimeout(timeout);
      } else {
        setShowDisclaimer(true);
      }
    } else {
      setDisplayedText(processedText);
      setShowDisclaimer(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndex, processedText, isAnimation]);

  useEffect(() => {
    if (refScrollText.current) {
      // refScrollText.current.scrollTop = refScrollText.current.scrollHeight;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayedText]);

  return <div className="typing-animation" dangerouslySetInnerHTML={{ __html: displayedText }} />;
};

const PopSideIonixAiSummaryTab = ({
  data,
  refScrollText,
  actionItemId
}: {
  data: any;
  refScrollText: any;
  actionItemId: any;
}) => {
  const [summary, setSummary] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [abortController, setAbortController] = useState<AbortController>();
  const { summaryAiRoleOptions, summaryAiSelectedRole } = useSelector((state: IReduxState) => state.popSide);
  const [isAnimation, setIsAnimation] = useState(true);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [disableFeedback, setDisableFeedback] = useState(false);
  // const { removeItem: removeStorageSearch } = useLocalStorage('ai_search');

  const dispatch: AppDispatch = useDispatch();
  const flags = useFlags();

  useEffect(() => {
    if (data) {
      if (flags?.isAiSummaryRoles && !summaryAiSelectedRole?.value) {
        fetchAiSummaryRoles();
      } else {
        fetchAiSummary();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, flags, summaryAiSelectedRole]);

  useEffect(() => {
    return () => {
      abortController?.abort();
    };
  }, [abortController]);

  const fetchAiSummary = () => {
    setIsLoading(true);
    setError(null);

    if (abortController) {
      abortController.abort();
    }
    const abort_controller = new AbortController();
    setAbortController(abort_controller);

    const role =
      flags?.isAiSummaryRoles && !!summaryAiSelectedRole?.value ? `?role=${summaryAiSelectedRole?.value}` : '';

    // if (!summaryMarkdown) {
    const queryUrl = `remediation/action-items/open/detailed/${actionItemId}/ai_summary/${role}`;

    RestApi.getData(queryUrl, true, abort_controller.signal).subscribe(
      (response: any) => {
        const summaryText = response && typeof response === 'string' ? response : 'No summary available';

        dispatch(setSummaryMarkdown(response && typeof response === 'string' ? summaryText : ''));
        setIsAnimation(true);
        setSummary(summaryText);
        setIsLoading(false);
      },
      error => {
        console.error('Error fetching AI summary:', error);
        setError('Failed to fetch AI summary. Please try again later.');
        setIsLoading(false);
      }
    );
    // } else {
    //   setIsAnimation(false);
    //   setSummary(summaryMarkdown);
    //   setIsLoading(false);
    // }
  };

  const fetchAiSummaryRoles = () => {
    setIsLoading(true);
    setError(null);

    // if (!summaryMarkdown) {
    const queryUrl = `remediation/action-items/open/detailed/ai_roles/`;

    RestApi.getData(queryUrl).subscribe(
      (response: any) => {
        const roles = response?.roles?.map((item: string) => ({ value: item, label: item }));
        dispatch(setSummaryAiRoleOptions(roles));
        dispatch(setSummaryAiSelectedRole(roles[0]));
      },
      error => {
        console.error('Error fetching AI summary Roles:', error);
        setError('Failed to fetch AI summary Roles. Please try again later.');
        setIsLoading(false);
      }
    );
    // } else {
    //   setIsAnimation(false);
    //   setSummary(summaryMarkdown);
    //   setIsLoading(false);
    // }
  };

  if (error) {
    return (
      <div className="PopSideIonixAiSummaryTab">
        <div className="data-item">
          <Text textSize={14} textColor="#FF4D4F" style={{ padding: '20px 24px' }}>
            {error}
          </Text>
        </div>
      </div>
    );
  }

  const handleCopyClipboard = () => {
    navigator.clipboard
      .writeText(`${summary}\n\n###Disclaimer:This summary was generated automatically using AI and may contain errors or omissions.
                    Please review the information carefully and do not rely solely on this summary for decision-making.
                    IONIX is not responsible for any inaccuracies or consequences resulting from the use of this summary`);
    dispatch(showSuccess('Copied to clipboard'));
  };

  const onChange = (option: any) => {
    setDisableFeedback(false);
    dispatch(setSummaryAiSelectedRole(option));
    setShowDisclaimer(false);
    Amplitude.save('AI_ROLE_SUMMARY', { role: summaryAiSelectedRole });
  };

  const handleThumb = (type: string) => () => {
    // console.log('XXX: ', { feedback: type, role: summaryAiSelectedRole });
    setDisableFeedback(true);
    Amplitude.save('AI_SUMMARY_THUMBS', { feedback: type, role: summaryAiSelectedRole });
    dispatch(showSuccess('Feedback submitted successfully'));
  };

  return (
    <div className="PopSideIonixAiSummaryTab">
      <div className="data-item" style={{ padding: '20px' }}>
        <div
          className={classNames('ai-summary-header', { disabled: isLoading })}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          {flags?.isAiSummaryRoles && !!summaryAiRoleOptions.length && summaryAiSelectedRole?.value && (
            <div className="DropdownList-wrapper" style={{ display: 'flex', alignItems: 'center' }}>
              <Text style={{ paddingRight: 8 }} textColor="#8C909A">
                Summary Style
              </Text>

              <DropdownList
                options={summaryAiRoleOptions}
                onChange={onChange}
                className="dropdown-user-type"
                defaultOption={summaryAiSelectedRole}
              />
            </div>
          )}
          <div style={{ flexGrow: 1 }} />
          <div className={classNames({ 'thumbs-disabled': disableFeedback })}>
            <span
              className={classNames('thumb-down', { blink: !disableFeedback && !isLoading })}
              onClick={handleThumb('down')}
              style={{ marginRight: 12, position: 'relative', top: 5 }}
            >
              {iconThumbsDown}
            </span>
            <span
              className={classNames('thumb-up', { blink: !disableFeedback && !isLoading })}
              style={{ paddingRight: 16, position: 'relative', bottom: -3 }}
              onClick={handleThumb('up')}
            >
              {iconThumbsUp}
            </span>
          </div>
          <div className="icon-clipboard" onClick={handleCopyClipboard}>
            <Text style={{ paddingRight: 8 }} textColor="#8C909A">
              Copy
            </Text>
            {iconClipboard}
          </div>
        </div>
        {isLoading ? (
          <ProgressSummary />
        ) : (
          <div>
            <div
              className="markdown-content"
              style={{
                fontSize: '14px',
                color: '#5D6576',
                whiteSpace: 'pre-line',
                lineHeight: '1.5'
              }}
            >
              <TypingAnimation
                refScrollText={refScrollText}
                text={summary}
                isAnimation={isAnimation}
                setShowDisclaimer={setShowDisclaimer}
              />
              {showDisclaimer && (
                <div style={{ display: 'flex', marginTop: 24, backgroundColor: '#F9FAFF' }}>
                  <div style={{ width: 8, backgroundColor: '#4B7AE7' }} />
                  <Text textColor="#4B7AE7" style={{ padding: 16 }} textSize={13}>
                    This summary was generated automatically using AI and may contain errors or omissions. Please review
                    the information carefully and do not rely solely on this summary for decision-making. IONIX is not
                    responsible for any inaccuracies or consequences resulting from the use of this summary.
                  </Text>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PopSideIonixAiSummaryTab;
